import React, {Component} from 'react'
import TableHead from "./TableHead"
import TableBody from "./TableBody"
import PropTypes from "prop-types"

class OrdersReportTable extends Component {

    render() {
        const {loading, orders, error} = this.props

        return (
            <div className="OrdersReportTable SkuTable">
                <table className="table table-striped">
                    <TableHead/>
                    <TableBody
                        orders={orders}
                        loading={loading}
                        error={error}
                    />
                </table>
            </div>
        )
    }
}

OrdersReportTable.propTypes = {
    error: PropTypes.string,
    orders: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired
}

export default OrdersReportTable